import React, { Component } from 'react'
import { apiProcess } from '../../../../api/api.js'
import { Button, Columns, Header } from 'components/elements'
import * as Yup from 'yup'
import moment from 'moment'
import {
  isUserInternational,
  fullStateFromShortCode,
  fullCountryFromShortCode,
  makeTitleCase,
} from '../../../../utils'
import { Formik, Form } from 'formik'
import LicenseCardInput from '../../../documents/licenseCardField'
import LicenseFields from '../../../documents/licenseFields'
import { licenseInitialValues } from '../../../documents/licenseFormInitialValues'
import { PARTNER_LICENSE, AGE_QUESTION_ERROR } from '../../main/constants.js'
import './../insuranceScreen.css'

const domesticValidation = Yup.object().shape({
  license_number: Yup.string()
    .nullable()
    .required('License Number is required.'),
  //license_country: Yup.string().nullable().required('Required'),
  //license_state: Yup.string().nullable().required('Required'),

  license_first_name: Yup.string()
    .nullable()
    .required('First Name is required.'),
  //license_middle_name: Yup.string().nullable().required('Required'),
  license_last_name: Yup.string()
    .nullable()
    .required('Last Name is required.'),

  license_birth_combo: Yup.string()
    .nullable()
    .required('Birthday is required.'),

  license_gender: Yup.string()
    .nullable()
    .required('Gender is required.'),
  license_exp_combo: Yup.string()
    .nullable()
    .required('Expiration is required.'),
  address_line_1: Yup.string()
    .nullable()
    .required('Address Line 1 is required.'),
  //address_line_2 : Yup.string().nullable().required('Required'),
  address_city: Yup.string()
    .nullable()
    .required('City is required.'),
  address_region: Yup.string()
    .nullable()
    .required('State/Region is required.'),
  address_country: Yup.string()
    .nullable()
    .required('Country is required.'),
  address_postal_code: Yup.number()
    .typeError('Postal Code is Required.')
    .required('Postal code is required.'),
})

const internationalValidation = Yup.object().shape({
  license_number: Yup.string()
    .nullable()
    .required('Required'),
  //: Yup.string().nullable().required('Required'),
  //license_state: Yup.string().nullable().required('Required'),

  license_first_name: Yup.string()
    .nullable()
    .required('First Name is required.'),
  // license_middle_name: Yup.string().nullable().required('Required'),
  license_last_name: Yup.string()
    .nullable()
    .required('Last Name is required.'),

  license_birth_combo: Yup.string()
    .nullable()
    .required('Birthday is required.'),
  license_exp_combo: Yup.string()
    .nullable()
    .required('Expiration is required.'),
  license_gender: Yup.string()
    .nullable()
    .required('Gender is required.'),
  address_line_1: Yup.string()
    .nullable()
    .required('Address Line 1 is required.'),
  //address_line_2 : Yup.string().nullable().required('Required'),
  address_city: Yup.string()
    .nullable()
    .required('Required'),
  address_region: Yup.string()
    .nullable()
    .required('State/Region is required'),
  address_country: Yup.string()
    .nullable()
    .required('Country is required.'),
  //address_postal_code : Yup.number().required('Required'),

  //license_card_images: Yup.array().of(Yup.string().nullable().required('Required')),
})

const licenseCardValidation = Yup.object().shape({
  license_card_images: Yup.array().of(
    Yup.string().required('License images are required.')
  ),
})

class PartnerLicenseScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      successBanner: false,
      insuranceBack: null,
      insuranceFront: null,
      licenseBack: null,
      licenseFront: null,
      licenseBackID: null,
      licenseFrontID: null,
      licenseScreenPage: 'fields', //can also be 'cards'
      errorMessages: [],
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(PARTNER_LICENSE)
  }

  routeLicenseEdits = (values, actions) => {
    if (this.state.licenseScreenPage === 'fields') {
      // alert()

      this.submitLicenseFieldEdits(values, actions)
    } else if (this.state.licenseScreenPage === 'cards') {
      //alert()
      this.submitLicenseCard(values, actions)
    } else {
      return false
    }
  }

  submitLicenseFieldEdits = (values, actions) => {
    //actions.setSubmitting(true)

    let birthday = moment(
      values.license_birth_year +
        '-' +
        values.license_birth_month +
        '-' +
        values.license_birth_date,
      'YYYY-MM-D',
      true
    )

    //alert(birthday.toString())

    //alert(values.license_exp_date)
    let expDate = moment(
      values.license_exp_year +
        '-' +
        values.license_exp_month +
        '-' +
        values.license_exp_date,
      'YYYY-MM-D',
      true
    )

    let documentSchema = domesticValidation

    let valuesToCheck = {
      license_number: values.license_number,
      // license_country: values.license_country,
      // license_state: values.license_state,

      license_first_name: values.license_first_name,
      license_middle_name: values.license_middle_name,
      license_last_name: values.license_last_name,

      license_gender: values.license_gender,

      license_birth_combo: birthday.isValid() ? birthday.toString() : '',
      license_exp_combo: expDate.isValid() ? expDate.toString() : '',
      address_line_1: values.address_line_1,
      //address_line_2 : Yup.string().nullable().required('Required'),
      address_city: values.address_city,
      address_region: values.address_region,
      address_country: values.address_country,
      address_postal_code: values.address_postal_code,
    }

    let license_age = moment().diff(birthday,'years')
    if(license_age < 25) {
      this.setState({
        licenseScreenPage: 'age_error',
      })
      this.props.onScreenLoad(AGE_QUESTION_ERROR)
      return false
    }
    else{
    }
    if (isUserInternational(values.address_country, values.address_region)) {
      documentSchema = internationalValidation

      //valuesToCheck.license_card_images = [this.state.licenseBack, this.state.licenseFront]
    }

    documentSchema
      .validate(valuesToCheck, { abortEarly: false })
      .then((valid) => {
        //alert('success here')
        //licenseScreenPage
        if (
          isUserInternational(values.address_country, values.address_region)
        ) {
          this.setState({
            licenseScreenPage: 'cards',
          })
        } else {
          this.finalizeEdits(values, actions, birthday, expDate)
        }

        actions.setSubmitting(false)
      })
      .catch((responseData) => {
        ////console.log(responseData)

        actions.setSubmitting(false)

        for (let i = 0; i < responseData.inner.length; i++) {
          actions.setFieldError(
            responseData.inner[i]['path'],
            responseData.inner[i]['message']
          )
          //setFieldError(responseData.inner[i]['path'], responseData.inner[i]['message'])
        }
      })
  }

  finalizeEdits = (values, actions, birthday, expDate) => {
    /////REFACTOR THIS NOW

    let addressCountryFull = fullCountryFromShortCode(values.address_country)

    let addressStateFull = fullStateFromShortCode(
      values.address_country,
      values.address_region
    )

    let apiURL = 'users/documents'
    let profileData = {}
    profileData = {
      drivers_license: {
        license_country: addressCountryFull,
        license_state: addressStateFull,
        license_no: values.license_number,
        //name_on_license: values.license_first_name + " " + values.license_middle_name + " " + values.license_last_name,
        first_name: values.license_first_name,
        middle_name: values.license_middle_name,
        last_name: values.license_last_name,
        //drivers_license_last_name: values.license_full_name,
        date_of_birth: birthday.format('YYYY-MM-DD'),
        gender: values.license_gender,

        expiration_date: expDate.format('YYYY-MM-DD'),
        //expiration_date: expDate.format('YYYY-MM-DD'),
        location: {
          address_street_1: values.address_line_1,
          address_street_2: values.address_line_2,
          //address_street_3, type: String
          address_city: values.address_city,
          address_state: addressStateFull,
          address_state_abbreviation: values.address_region,
          address_zip: values.address_postal_code,
          address_country: addressCountryFull,
        },
      },
    }

    if (isUserInternational(values.address_country, values.address_region)) {
      profileData.drivers_license['images'] = {
        drivers_license_front_image: {
          cloudinary_public_id: this.state.licenseFrontID,
        },
        drivers_license_back_image: {
          cloudinary_public_id: this.state.licenseBackID,
        },
      }
    }

    apiProcess(
      apiURL,
      profileData,
      'update-license-insurance',
      'Update License and License Images from Payment Page Wizard'
    )
      .then(
        function(responseData) {
          //show success banner.
          //clear all errors form. that includes birthdays
          this.setState({
            generalError: false,
          })
          this.props.onSuccess()
          actions.setSubmitting(false)
        }.bind(this)
      )
      .catch(
        function(responseData) {
          //show failure banner.
          this.setState({
            generalError: true,
          })

          let formattedErrorMessages = []
          responseData.errorResponseData.error_messages.forEach((error, id) => {
            formattedErrorMessages.push(makeTitleCase(error))
          })

          this.setState({
            errorMessages: formattedErrorMessages,
          })

          //alert('CHANGE WHEN API IS UP')
          //this.props.onSuccess()
          actions.setSubmitting(false)
          //If there are errors to parse out, we will do them here.
          //for now just do a banner error right here.
        }.bind(this)
      )
  }

  changeLicense = (side, imageURL, imageID) => {
    //alert()

    if (side === 'front') {
      this.setState({
        licenseFront: imageURL,
        licenseFrontID: imageID,
      })
    }

    if (side === 'back') {
      this.setState({
        licenseBack: imageURL,
        licenseBackID: imageID,
      })
    }
  }

  submitLicenseCard = (values, actions) => {
    let valuesToCheck = {
      license_card_images: [
        this.state.licenseBackID,
        this.state.licenseFrontID,
      ],
    }

    licenseCardValidation
      .validate(valuesToCheck, { abortEarly: false })
      .then(
        function(valid) {
          let birthday = moment(
            values.license_birth_year +
              '-' +
              values.license_birth_month +
              '-' +
              values.license_birth_date,
            'YYYY-MM-D',
            true
          )

          let expDate = moment(
            values.license_exp_year +
              '-' +
              values.license_exp_month +
              '-' +
              values.license_exp_date,
            'YYYY-MM-D',
            true
          )

          this.finalizeEdits(values, actions, birthday, expDate)
        }.bind(this)
      )
      .catch((responseData) => {
        //console.log(responseData)

        actions.setSubmitting(false)

        for (let i = 0; i < responseData.inner.length; i++) {
          actions.setFieldError(
            responseData.inner[i]['path'],
            responseData.inner[i]['message']
          )
          //setFieldError(responseData.inner[i]['path'], responseData.inner[i]['message'])
        }
      })
  }

  render() {
    const { lockedLicense, licenseScreenPage } = this.state
    return (
      <React.Fragment>
        <Formik
          initialValues={licenseInitialValues()} //this.state.data.drivers_license)}
          //validationSchema={documentSchema}
          onSubmit={(values, actions) =>
            this.routeLicenseEdits(values, actions)
          }
          render={({ errors, setFieldValue, isSubmitting, values }) => (
            <Form>
              {this.state.generalError && (
                <div className="is-size-6 mt-3 mb-3 has-text-danger">
                  {this.state.errorMessages.length > 0 && (
                    <span>{this.state.errorMessages[0]}</span>
                  )}

                  {this.state.errorMessages.length === 0 && (
                    <span>
                      Sorry we are having issues right now. Please try again.
                    </span>
                  )}
                </div>
              )}
              {licenseScreenPage === 'age_error' &&(
                <div className="has-text-centered">
                  <Columns className="has-text-centered is-mobile is-centered">
                    <Columns.Column size={10}>
                      <Header size={5} className="has-text-weight-extra-bold">
                        Sorry.
                      </Header>
                      <i className="fad fa-baby fa-10x has-text-danger"></i>
                      <p className="has-text-weight-extra-bold is-size-5 mb-0">
                        You must be 25 years or older to rent from this Twisted Road partner.
                      </p>
                      <p className="is-size-6 mb-6">
                        Return to our homepage and search for another bike.
                        If you need assistance, contact us at info@twistedroad.com.
                      </p>
                      <a className="button gold-button is-medium is-fullwidth has-text-weight-bold is-primary" href="/">
                        Got it. Search bikes.
                      </a>
                      <br />
                    </Columns.Column>
                  </Columns>
                </div>
              )}

              {licenseScreenPage === 'fields' && (
                <React.Fragment>
                  <Header size={5} className="has-text-weight-extra-bold">
                    License Information
                  </Header>
                  <LicenseFields
                    licenseData={values}
                    errors={errors}
                    locked={lockedLicense}
                    onChange={setFieldValue}
                    showSubDescription={false}
                  />
                  <Button
                    color="primary"
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    size="medium"
                    type="submit"
                  >
                    Save License Information
                  </Button>
                </React.Fragment>
              )}

              {licenseScreenPage === 'cards' && (
                <React.Fragment>
                  {isUserInternational(
                    values.address_country,
                    values.address_region
                  ) && (
                    <React.Fragment>
                      <Header
                        size={5}
                        className="has-text-weight-bold mt-4 mb-0"
                      >
                        License Images
                      </Header>
                      <p className="mb-4">
                        Because you reside outside of the United States of
                        America, we'll also need copies of your driver's
                        license.
                      </p>

                      <LicenseCardInput
                        onChange={this.changeLicense}
                        error={errors.license_card_images}
                        //licenseFront={licenseFront}
                        //licenseBack={licenseBack}
                      />
                      <Button
                        className="mt-3"
                        color="primary"
                        fullwidth
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        size="medium"
                      >
                        Save License Images
                      </Button>
                    </React.Fragment>
                  )}
                  {this.props.skippable && (
                    <div className="mt-2 has-text-centered">
                      <span
                        className="is-size-7 finger-pointer"
                        onClick={() => this.props.onSuccess()}
                      >
                        I'll do this later
                      </span>
                    </div>
                  )}
                </React.Fragment>
              )}
            </Form>
          )}
        />
      </React.Fragment>
    )
  }
}
export default PartnerLicenseScreen

PartnerLicenseScreen.defaultProps = {
  //insuranceBack : null,
  //insuranceFront : null,
  //error: false,
  //showSubDescription : true,
  //onChange : null
  onSuccess: function() {},
  skippable: true,
  onScreenLoad: function() {},
}
